export default "__VITE_ASSET__C3AO4MoV__"